import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { addUser } from '../../redux/userslice';
import Token from "../../ApiCheck/Token";
import { jwtDecode } from 'jwt-decode';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import Loader from '../../ApiCheck/Loader';
import { baseUrl } from '../../ApiCheck/Constant';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user.isAuth) {
      if (user.user.role === 'ADMIN') {
        navigate("/dashboard");
      } else {
        navigate("/");
      }
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const login = await axios.post(`${baseUrl}/api/signin`, data);
      localStorage.setItem("token", login?.data?.token);

      Token(login.data.token);
      const decoded = jwtDecode(login.data.token);
      dispatch(addUser(decoded));
      toast.success('Login Successful', { position: 'top-center', autoClose: 3000 });

      if (login.data.data.role === 'ADMIN') {
        navigate("/dashboard");
      } else {
        navigate("/");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, { position: 'top-center', autoClose: 3000 });
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <div className="wrapper w-50 bg-white mt-2 text-dark rounded shadow-lg p-4">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="title h2 text-center mb-4">Login Form</div>
            <form className='register-data' method="POST" onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={data.email}
                  onChange={handleOnChange}
                  required
                  autoComplete='off'
                  className="form-control border-dark"
                  placeholder="Enter your email"
                />
              </div>
              <div className="mb-3 position-relative">
                <label htmlFor="password" className="form-label">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={data.password}
                  name="password"
                  onChange={handleOnChange}
                  required
                  autoComplete='off'
                  className="form-control border-dark"
                  placeholder="Enter your password"
                />
                <span 
                  className="position-absolute top-50 end-0 translate-middle-y m-3" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
                </span>
              </div>
              <div className="mb-3">
                <input type="submit" value="Login" className="btn btn-dark w-100" />
              </div>
              <div className="signup-link text-center">
                Don't have an account? <Link to="/register" className="text-dark">Register</Link>
                <br />
                <Link to="/forgot-password" className="text-dark">Forgot Password?</Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
